const NAVIGATION_KEYS = new Set([
  'Tab',
  'Enter',
  'Escape',
  'Backspace',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
]);

export const numericKeyboardGuard = ({
  params,
  allowDecimal = false,
}) => {
  if (!params.editing) return false;

  const { key, ctrlKey, metaKey } = params.event;

  // Allow copy / paste / select all
  if (ctrlKey || metaKey) return false;

  // Allow navigation keys
  if (NAVIGATION_KEYS.has(key)) return false;

  // Allow numbers
  if (/^[0-9]$/.test(key)) return false;

  // Allow decimal point if configured
  if (allowDecimal && key === '.') return false;

  // Block everything else
  return true;
};
